module.exports = __webpack_public_path__ + "static/media/parallax-img-2.b2f3eef9.jpg";